import { setRangeMin } from './helpers';

export const setFloorsMin = setRangeMin('floorn');
